import { render, staticRenderFns } from "./addressDetail.vue?vue&type=template&id=76b34510&"
import script from "./addressDetail.vue?vue&type=script&lang=js&"
export * from "./addressDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports